export default {
  en: {
    loading: 'Loading...',
    empty: 'No chats to show',
    empty_search: 'Search returned no results',
    error: 'Something went wrong while loading the chats',
  },
};
